import type { CXPublicSurveyResponse } from '../../services/cxPublicSurveyService';

/** Host-owned preview state cannot be enabled by survey configuration or API JSON. */
const contexts = new WeakMap<
  CXPublicSurveyResponse,
  { locale: string; initialScreenId?: string }
>();

export function markCanonicalPreview(
  response: CXPublicSurveyResponse,
  options: { locale: string; initialScreenId?: string }
) {
  contexts.set(response, Object.freeze({ ...options }));
  return response;
}

export function canonicalPreviewContext(response: CXPublicSurveyResponse) {
  return contexts.get(response);
}
